import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize20 {
  size?: '20';
}
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize20 | OverrideIconSize24;

const SvgComponent = ({
  size = '20',
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '20') {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.91909 9.3145C7.05813 8.67689 6.5 7.65362 6.5 6.5C6.5 4.567 8.067 3 10 3C11.933 3 13.5 4.567 13.5 6.5C13.5 7.65362 12.9419 8.67689 12.0809 9.3145C14.9307 10.2006 17 12.8586 17 16C17 16.2761 16.7761 16.5 16.5 16.5C16.2239 16.5 16 16.2761 16 16C16 12.6863 13.3137 10 10 10C6.68629 10 4 12.6863 4 16C4 16.2761 3.77614 16.5 3.5 16.5C3.22386 16.5 3 16.2761 3 16C3 12.8586 5.06926 10.2006 7.91909 9.3145ZM10 9C11.3807 9 12.5 7.88071 12.5 6.5C12.5 5.11929 11.3807 4 10 4C8.61929 4 7.5 5.11929 7.5 6.5C7.5 7.88071 8.61929 9 10 9Z"
          fill={color}
        />
        <path d="M14.5 5.5H17.5M16 4V7" stroke={color} strokeLinecap="round" />
      </svg>
    );
  }
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.5 10C18.2239 10 18 9.77614 18 9.5V7H15.5C15.2239 7 15 6.77614 15 6.5C15 6.22386 15.2239 6 15.5 6H18V3.5C18 3.22386 18.2239 3 18.5 3C18.7761 3 19 3.22386 19 3.5V6H21.5C21.7761 6 22 6.22386 22 6.5C22 6.77614 21.7761 7 21.5 7H19V9.5C19 9.77614 18.7761 10 18.5 10ZM7.8048 11.3444C6.71767 10.6293 6 9.39847 6 8C6 5.79086 7.79086 4 10 4C12.2091 4 14 5.79086 14 8C14 9.39847 13.2823 10.6293 12.1952 11.3444C15.5462 12.4165 18 15.843 18 19.5C18 19.7761 17.7761 20 17.5 20C17.2239 20 17 19.7761 17 19.5C17 15.634 13.866 12 10 12C6.13401 12 3 15.634 3 19.5C3 19.7761 2.77614 20 2.5 20C2.22386 20 2 19.7761 2 19.5C2 15.843 4.45382 12.4165 7.8048 11.3444ZM10 11C11.6569 11 13 9.65685 13 8C13 6.34315 11.6569 5 10 5C8.34315 5 7 6.34315 7 8C7 9.65685 8.34315 11 10 11Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 20, 24 입니다.
 *
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'managerAdd');
export default IconComponent;
